export interface BorcRecord {
  id: number;
  tedarikciAdi: string;
  borcTuru: "Altın" | "İşçilik" | "Taş" | "Ürün" | "Diğer";
  tutar: number;
  odenen: number;
  kalan: number;
  vadeTarihi: string;
  durum: "Bekliyor" | "Yaklaştı" | "Gecikti" | "Ödendi";
  not: string;
}

export const borclarData: BorcRecord[] = [
  {
    id: 1,
    tedarikciAdi: "Altınbaş Tedarik",
    borcTuru: "Altın",
    tutar: 150000,
    odenen: 75000,
    kalan: 75000,
    vadeTarihi: "2026-05-05",
    durum: "Yaklaştı",
    not: "Gram altın tedariki.",
  },
  {
    id: 2,
    tedarikciAdi: "Mestan Kuyumculuk",
    borcTuru: "İşçilik",
    tutar: 45000,
    odenen: 15000,
    kalan: 30000,
    vadeTarihi: "2026-04-29",
    durum: "Gecikti",
    not: "Özel sipariş işçilik ücreti.",
  },
  {
    id: 3,
    tedarikciAdi: "Diamond House",
    borcTuru: "Taş",
    tutar: 89000,
    odenen: 50000,
    kalan: 39000,
    vadeTarihi: "2026-05-08",
    durum: "Bekliyor",
    not: "0.50ct pırlanta tedariki.",
  },
  {
    id: 4,
    tedarikciAdi: "Kuyumcu Hırdavat",
    borcTuru: "Ürün",
    tutar: 12500,
    odenen: 12500,
    kalan: 0,
    vadeTarihi: "2026-04-20",
    durum: "Ödendi",
    not: "Alet ve ekipman alımı.",
  },
  {
    id: 5,
    tedarikciAdi: "İstanbul Kuyumcu Sarraf",
    borcTuru: "Altın",
    tutar: 210000,
    odenen: 100000,
    kalan: 110000,
    vadeTarihi: "2026-05-10",
    durum: "Bekliyor",
    not: "22 ayar altın külçe.",
  },
  {
    id: 6,
    tedarikciAdi: "Özel Taş İthalat",
    borcTuru: "Taş",
    tutar: 67000,
    odenen: 67000,
    kalan: 0,
    vadeTarihi: "2026-04-15",
    durum: "Ödendi",
    not: "Safir ve zümrüt tedariki.",
  },
  {
    id: 7,
    tedarikciAdi: "Aktif Kuyumculuk",
    borcTuru: "Diğer",
    tutar: 8500,
    odenen: 0,
    kalan: 8500,
    vadeTarihi: "2026-04-30",
    durum: "Gecikti",
    not: "Kargo ve lojistik borcu.",
  },
  {
    id: 8,
    tedarikciAdi: "Altın Dünyası",
    borcTuru: "Altın",
    tutar: 175000,
    odenen: 87500,
    kalan: 87500,
    vadeTarihi: "2026-05-06",
    durum: "Yaklaştı",
    not: "14 ayar altın takı seti.",
  },
];